export default __webpack_public_path__ + "static/video-3-55bc477c8275426f7865597a78c0150b.mp4";